import { React, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  MenuItem,
  FormControl,
  Select,
  TextField,
  Input,
} from "@material-ui/core";
import "./ParametersContainer.css";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: "60%",
    overflow: "scroll",
    marginLeft: 20,
    position: "relative",
    top: 20,
  },
  formControl: {
    minWidth: 150,
    position: "relative",
    bottom: 5,
  },
  textField: {
    position: "relative",
    bottom: 5,
  },
}));

const ParametersContainer = (props) => {
  const [inputValue, setInputValue] = useState(2);
  const classes = useStyles();
  let obj = {};
  props.data.forEach((parameter) => {
    const { type, name, data } = parameter;
    if (type === "dropdown") {
      obj = { ...obj, [name]: data[0] };
    }
  });
  const [dropdownValue, setDropdownValue] = useState(obj);

  const handleChange = (event, name) => {
    setDropdownValue({ ...dropdownValue, [name]: event.target.value });
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value === "" ? "" : Number(event.target.value));
  };

  const renderParameter = props.data.map((parameter, index) => {
    const { name, type, data } = parameter;
    return (
      <Grid key={index} container spacing={3}>
        <Grid item xs={6}>
          {name}
        </Grid>
        {type === "dropdown" && (
          <Grid item xs={3}>
            <FormControl className={classes.formControl}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={dropdownValue[name]}
                onChange={(event) => handleChange(event, name)}
              >
                {data.map((value, index) => (
                  <MenuItem key={index} value={value}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        {type === "text" && (
          <Grid item xs={3}>
            <form className={classes.textField} noValidate autoComplete="off">
              <TextField id={`standard-basic${index}`} defaultValue={data[0]} />
            </form>
          </Grid>
        )}
        {type === "input" && (
          <>
            <Grid item xs={3}>
              <Input
                value={inputValue}
                margin="dense"
                onChange={handleInputChange}
                inputProps={{
                  step: 1,
                  min: 1,
                  max: 20,
                  type: "number",
                  "aria-labelledby": "input-slider",
                }}
              />
            </Grid>
            <Grid item xs={6}>
              Units
            </Grid>
            <Grid item xs={3}>
              {new Array(inputValue).fill(0).map((i, ind) => {
                return (
                  <form
                    key={ind}
                    className={classes.textField}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField id={`${ind}standard-basic`} defaultValue={10} />
                  </form>
                );
              })}
            </Grid>
          </>
        )}
      </Grid>
    );
  });

  return <div className={classes.mainContainer}>{renderParameter}</div>;
};

export default ParametersContainer;
